import { type RefObject, useLayoutEffect, useState } from "react";

export function useLayoutWidth(ref: RefObject<HTMLElement | null>): number {
    const [width, setWidth] = useState(0);

    useLayoutEffect(() => {
        const element = ref.current;
        if (!element) return undefined;
        // Measure before first paint, or panels spend a frame at min width and fetch at that resolution.
        setWidth(element.clientWidth);
        // Floor: the canvas width attribute is an integer, so a fractional width leaves the bitmap scaled.
        const observer = new ResizeObserver(([entry]) => setWidth(Math.floor(entry.contentRect.width)));
        observer.observe(element);
        return () => observer.disconnect();
    }, [ref]);

    return width;
}
